import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function scrollPageToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView();
        return;
      }
    }

    scrollPageToTop();
    requestAnimationFrame(scrollPageToTop);
  }, [pathname, search, hash]);

  return null;
}
